import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from './components/AppNavbar';
import Header from './components/Header';
import MainGrid from './components/MainGrid';
import SideMenu from './components/SideMenu';
import AppTheme from '../shared-theme/AppTheme';
import { FontScaleProvider } from './contexts/FontScaleContext';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function Dashboard(props) {
  const { children } = props;
  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <FontScaleProvider>
        <CssBaseline enableColorScheme />
        <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflowX: 'hidden',
            overflowY: 'auto',
            maxWidth: '100%',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header />
            {children != null ? (
              <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
                {children}
              </Box>
            ) : (
              <MainGrid />
            )}
          </Stack>
        </Box>
      </Box>
      </FontScaleProvider>
    </AppTheme>
  );
}
